import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpired = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.12 5.55a.62.62 0 0 0-.61.63v12.64c0 .35.27.63.61.63h6.69c.41 0 .75.35.75.77 0 .43-.34.78-.75.78H2.12A2.15 2.15 0 0 1 0 18.82V6.18C0 4.98.95 4 2.12 4h17.76C21.05 4 22 4.98 22 6.18v3.7c0 .42-.34.77-.75.77a.77.77 0 0 1-.76-.77v-3.7a.62.62 0 0 0-.61-.63H2.12Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.97 8.93a.59.59 0 0 0-.48.6v5.96a.6.6 0 0 0 .5.6c1.34.2 2.69.34 4.04.4.4.03.72.38.7.8a.75.75 0 0 1-.77.7c-1.4-.06-2.81-.2-4.2-.42-.5-.08-.94-.33-1.27-.71-.32-.39-.5-.87-.49-1.38h.74H3V9.53h.74H3a2.12 2.12 0 0 1 1.72-2.08h.01c2.13-.33 4.28-.48 6.42-.45 2.15-.03 4.3.12 6.42.45h.02c.49.09.92.34 1.24.73.26.32.22.79-.1 1.06a.74.74 0 0 1-1.05-.1.59.59 0 0 0-.34-.2 36.6 36.6 0 0 0-6.2-.43 36.6 36.6 0 0 0-6.17.42ZM9.26.16c.3-.24.76-.2 1.02.08L13 3.28 15.72.24a.76.76 0 0 1 1.02-.08c.3.23.35.66.1.94l-3.28 3.66A.75.75 0 0 1 13 5a.75.75 0 0 1-.56-.24L9.17 1.1a.64.64 0 0 1 .1-.94ZM19.9 19.9c-.29.3-.76.3-1.06 0l-4.24-4.24a.75.75 0 1 1 1.06-1.06l4.24 4.24c.3.3.3.77 0 1.06Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.9 14.6c.3.3.3.77 0 1.06l-4.24 4.24a.75.75 0 0 1-1.06-1.06l4.24-4.24c.3-.3.77-.3 1.06 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.5 17.25a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0Zm-5.25-6.75a6.75 6.75 0 1 1 0 13.5 6.75 6.75 0 0 1 0-13.5Z"
		})
	]
});
export { SvgExpired as ReactComponent };
